import { createSlice } from '@reduxjs/toolkit';

import product1 from "../../images/products/product1.jpg";
import product2 from "../../images/products/product2.png";
import product3 from "../../images/products/product3.png";
import product4 from "../../images/products/product4.png";

import service1 from "../../images/services/service1.JPG";
import service2 from "../../images/services/service2.JPG";
import service3 from "../../images/services/service3.JPG";

import review1 from "../../images/reviews/review1.png";

export const initialState = {
    products: [
        { id: 1, title: "Product 1", description: "Procedure aimed at deep cleansing", image: product1, price: 100},
        { id: 2, title: "Product 2", description: "Short Description of Product 2", image: product2, price: 200 },
        { id: 3, title: "Product 3", description: "Short Description of Product 3", image: product3, price: 300 },
        { id: 4, title: "Product 4", description: "Short Description of Product 4", image: product4, price: 400 },
    ],
    services: [
        { id: 1, title: "Facial Cleansing", description: "Aimed at deep facial cleansing", image: service1, price: 80, text: "This is a procedure aimed at deep cleansing the skin of impurities, excess sebum and dead cells. This process includes several stages, such as steaming, mechanical or ultrasonic cleansing, as well as applying soothing and nourishing masks. The result is fresh, healthy and radiant skin, free from blackheads and breakouts. Regular facial cleansing helps prevent acne and improves skin texture and tone, giving it a well-groomed and youthful appearance." },
        { id: 2, title: "Massage", description: "For blood circulation and stress relief", image: service2, price: 60, text: "This is the art of influencing the body with the help of hands, aimed at relaxing muscles, improving blood circulation and relieving tension. Depending on the technique, the massage can be soothing or tonic, deeply working the muscles or gently relaxing. It helps reduce stress, improve overall well-being and restore harmony between body and mind. Regular massage helps strengthen the immune system, improve sleep and improve overall vitality, making life more balanced and healthy." },
        { id: 3, title: "Skin Type Care", description: "Care according to facial skin type", image: service3, price: 50, text: "This is an individualized approach to maintaining the health and beauty of the skin, taking into account its specific needs. Dry skin needs deep hydration and nutrition, oily skin needs products that control sebum production, and combination skin needs balanced care for different areas of the face. Sensitive skin requires gentle, hypoallergenic products. The right products help maintain balance, prevent problems and highlight the natural radiance of the skin, giving it a fresh and well-groomed appearance." },
        { id: 3, title: "RF Skin Tightening", description: "Radio Frequency treatment", image: service3, price: 70, text: "This is a non-invasive cosmetic procedure aimed at rejuvenating the skin using radio frequency waves. These waves penetrate the deep layers of the dermis, stimulating the production of collagen and elastin, which leads to tightening and improving skin texture. RF lifting provides a visible lifting effect without surgical intervention, making the skin more toned and youthful." },
        { id: 3, title: "Pealing", description: "Skin renewal by removing dead cells", image: service3, price: "60-80", text: "This is a cosmetic procedure aimed at renewing the skin by removing the top layer of dead cells. The use of various types of peelings (chemical, mechanical, enzymatic) helps accelerate regeneration, improve skin texture and tone, and stimulate collagen production. As a result, the skin becomes smoother, fresher and more youthful. Peels promote deep cleansing and renewal of the skin, improving its appearance and health, making it more radiant and smooth." },
        { id: 3, title: "Microcurrent therapy", description: "Impulses to stimulate skin cells", image: service3, price: 70, text: "This is a cosmetic procedure that uses low-frequency electrical impulses to stimulate skin cells, improve muscle tone and stimulate the production of collagen and elastin. This technique helps improve microcirculation, activate metabolic processes and accelerate tissue regeneration. Microcurrent therapy is a safe and effective way to rejuvenate the skin, helping to improve its structure and appearance without invasive methods." },
    ],
    cart: [],
    bestSellers: [1, 2, 3],
    bestServices: [1, 2, 3],
    reviews: [
        { name: "Maria S", description: "Good service", rating: 5, image: review1 },
        { name: "Maria D", description: "Best service", rating: 5, image: review1 },
        { name: "Maria I", description: "Welcoming service", rating: 5, image: review1 }
    ]
};

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        addItem: (state, action) => {
            let matched = false;

            state.cart.forEach((item, index) => {
                if (item.id === action.payload.id) {
                    state.cart[index] = { ...item, amount: item.amount + 1 };
                    matched = true;
                }
            });

            if (!matched) {
                state.cart.push({ id: action.payload.id, amount: 1 });
            }
        },
        removeItem: (state, action) => {
            state.cart.forEach((item, index) => {
                if (item.id === action.payload.id) {
                    if (item.amount === 1) {
                        state.cart.splice(index, 1);
                    } else {
                        state.cart[index] = { ...item, amount: item.amount - 1 };
                    }
                }
            });
        },
        emptyCart: (state) => {
            state.cart = [];
        },
    },
    selectors: {
        selectApp: (state) => state
    }
});

export const { addItem, removeItem, emptyCart } = appSlice.actions;
export const { selectApp } = appSlice.selectors;